import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-analysis-edit",
  "use": "app-icon-analysis-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-analysis-edit\"><path d=\"M14.9 8h-1c-.1 0-.1.1-.1.1v5.5H2.4V2.4h5.5l.1-.1V1.1L7.9 1H1.6c-.4 0-.6.2-.6.6v12.9c0 .3.2.5.6.5h12.9c.3 0 .6-.3.6-.6V8.1c-.1 0-.2-.1-.2-.1z\" /><path d=\"M5.3 8.4v2.1c0 .2.1.3.3.3l2.1-.1h.1L15 3.4v-.2L12.8 1h-.1-.1L5.3 8.4c0-.1 0 0 0 0zm1.1.4l6.3-6.3.8.8-6.3 6.3h-.8v-.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol